import { type FC } from 'react';
import { ConstructSucces } from '@common/components/ConstructSuccess/ConstructSuccess';
import { selectFactoryByIdOrName } from '@redux/selectors/factoryReducer';
import { useAppSelector } from '@redux/store';

interface FactoryBuildCompleteProps {
  name: string;
}

const FactoryBuildComplete: FC<FactoryBuildCompleteProps> = ({ name }) => {
  const factory = useAppSelector((state) =>
    selectFactoryByIdOrName(state, name),
  );

  return (
    factory && (
      <ConstructSucces
        name={factory.name}
        kind="factory"
        id={factory.id}
        level={factory.level}
      />
    )
  );
};

export { FactoryBuildComplete };
